import React from "react";
// Components
import { Grid } from "@mui/material";
import { InputButton } from "components/UI";
// Utils
import { messageDisplay, responseErrors } from "utils";
import { validationSearchForm } from "utils/validation";
import { transformData } from "../hooks/tranformData";
//Service
import { useExportInvoiceSearchMutation } from "shared/services/invoice";
//Type
import { DEFAULT_EXPORT_INVOICE_INFO } from "../constants/constants";
import { BUTTON_VALUE, FIRST_PAGE, PAGINATION, ROW_PER_PAGE } from "shared/constants";
import { MSG_TYPE, MessageType, ModeAction } from "state/enum";
import { useLoadingContext } from "shared/contexts/LoadingContext";
import { useSelector } from "react-redux";
export default function ButtonCriterial(props) {
  const {
    setMode,
    form,
    setForm,
    setRows,
    setOnSearch,
    setMsg: { setMsgAlert, setMsgError },
    stateButton: { searchBtn, clearBtn },
    rowSelection: { setRowModesModel, setRowSelectionModel },
    pagination: { setPagination, setPageNumber },
    functionId,
  } = props;
  const userInfo = useSelector(state => state.auth.user);
  const searchExportInfo = useExportInvoiceSearchMutation();
  const { startLoading, stopLoading } = useLoadingContext();
  const handleSearch = async event => {
    try {
      event.preventDefault();
      setMsgAlert([]);
      setMsgError([]);
      // Reset Data of Table
      setPageNumber(FIRST_PAGE);
      setPagination({});
      setMode(ModeAction.VIEW);
      setOnSearch(false);
      setForm(prev => ({ ...prev, totalsM3Flag: true, reportFormatCd: "" }));
      setRows([]);
      setRowSelectionModel([]);
      setRowModesModel({});
      const body = {
        importerId: form?.importerId,
        vesselName: form?.vesselName,
        invoiceNo: form?.invoiceNo,
        etdFrom: form?.etdFrom,
        etdTo: form?.etdTo,
        loginUserCompanyAbbr: userInfo.companyAbbr, // TODO: mock constants here
        [PAGINATION.PAGE_NUMBER]: FIRST_PAGE,
        [PAGINATION.ROW_PER_PAGE]: ROW_PER_PAGE,
      };
      const { isSuccess, errors } = validationSearchForm({
        data: body,
        rule: [
          {
            field: "importerId",
            type: MessageType.EMPTY,
            key: ["Importer"],
          },
        ],
      });

      if (!isSuccess) {
        setMsgError(errors);
        window.scrollTo(0, 0);
        return;
      }
      startLoading();
      const searchData = await searchExportInfo(body);
      stopLoading();
      if (!searchData?.result?.data?.length) {
        setMsgError([
          messageDisplay({
            type: MSG_TYPE.ERROR,
            code: "MSTD0059AERR",
            msg: "",
          }),
        ]);
        return;
      }
      const data = transformData(searchData?.result?.data);
      setRows(data);
      setPagination(searchData?.result?.pagination ?? {});
      setPageNumber(searchData?.result?.pagination?.pageNumber);
      setOnSearch(true);
    } catch (error) {
      stopLoading();
      const errors = responseErrors(error);
      setMsgError(errors);
      return;
    }
  };
  const handleClear = () => {
    setMsgAlert([]);
    setMsgError([]);
    setForm(DEFAULT_EXPORT_INVOICE_INFO);
    setPageNumber(FIRST_PAGE);
    setRows([]);
    setPagination({});
    setRowSelectionModel([]);
    setRowModesModel({});
    setOnSearch(false);
    setMode(ModeAction.VIEW);
  };
  return (
    <Grid container justifyContent={"flex-end"} marginTop={2} marginBottom={1}>
      <Grid item>
        <InputButton
          id="button-search-export-inv"
          tabIndex={0}
          value={BUTTON_VALUE.SEARCH}
          disabled={searchBtn}
          onClick={handleSearch}
          marginRight="8px"
          name={`${functionId}Search`}
        />
        <InputButton
          id="button-clear"
          tabIndex={0}
          value={BUTTON_VALUE.CLEAR}
          disabled={clearBtn}
          onClick={handleClear}
          marginRight="0"
          name={`${functionId}Clear`}
        />
      </Grid>
    </Grid>
  );
}
